import {extendTheme} from '@mui/joy/styles';
import type {PaletteRange} from '@mui/joy/styles';
import "@fontsource/raleway"

declare module '@mui/joy/styles' {
    interface ColorPalettePropOverrides {
        secondary: true;
    }

    interface Palette {
        secondary: PaletteRange;
    }
}


const regularTheme = extendTheme({
    fontFamily: {
        body: "Raleway, sans-serif",
        display: "Raleway, sans-serif",
    },
    colorSchemes: {
        light: {
            palette: {
                primary: {
                    50: "#fbd9f0",
                    100: "#fcc4ea",
                    200: "#fdade5",
                    300: "#ff95e0",
                    400: "#ff7bdc",
                    500: "#ff69d9",
                    600: "#ff2dd3",
                    700: "#f100c6",
                    800: "#da01b4",
                    900: "#c500a2",
                },
                secondary: {
                    50: '#eff6ff',
                    100: '#dbeafe',
                    200: '#bfdbfe',
                    300: '#93c5fd',
                    400: '#60a5fa',
                    500: '#3b82f6',
                    600: '#2563eb',
                    700: '#1d4ed8',
                    800: '#1e40af',
                    900: '#1e3a8a',
                    solidColor:'var(--joy-palette-common-white)',
                    solidBg: 'var(--joy-palette-secondary-500)',
                    solidActiveBg: 'var(--joy-palette-secondary-700)',

                    outlinedBorder: 'var(--joy-palette-secondary-300)',
                    outlinedColor: 'var(--joy-palette-secondary-500)',
                    outlinedActiveBg: 'var(--joy-palette-secondary-200)',
                    outlinedHoverBg:'var(--joy-palette-secondary-100)',

                    softColor: 'var(--joy-palette-secondary-700)',
                    softBg: 'var(--joy-palette-secondary-100)',
                    softActiveBg: 'var(--joy-palette-secondary-300)',
                    // @ts-ignore
                    softActiveColor: 'var(--joy-palette-secondary-800)',

                    plainColor: 'var(--joy-palette-secondary-500)',
                    plainActiveBg: 'var(--joy-palette-secondary-200)',
                    plainHoverBg:'var(--joy-palette-secondary-100)'
                }
            }
        },
        dark: {
            palette: {
                primary: {
                    50: "#f100c6",
                    100: "#da01b4",
                    200: "#c500a2",
                    300: "#af0090",
                    400: "#9a007e",
                    500: "#86016d",
                    600: "#72005d",
                    700: "#5e044c",
                    800: "#4a063c",
                    900: "#37062c",
                },
                secondary: {
                    50: '#d2e3ff',
                    100: '#9fc2ff',
                    200: '#6da3ff',
                    300: '#4688ff',
                    400: '#315cc4',
                    500: '#256ee6',
                    600: '#284a9c',
                    700: '#1f3470',
                    800: '#14234d',
                    900: '#0c132b',
                    solidColor:'var(--joy-palette-common-white)',
                    solidBg: 'var(--joy-palette-secondary-500)',
                    solidActiveBg: 'var(--joy-palette-secondary-600)',
                    outlinedBorder: 'var(--joy-palette-secondary-700)',
                    outlinedColor: 'var(--joy-palette-secondary-200)',
                    outlinedActiveBg: 'var(--joy-palette-secondary-700)',
                    outlinedHoverBg:'var(--joy-palette-secondary-800)',
                    softColor: 'var(--joy-palette-secondary-200)',
                    softBg: 'var(--joy-palette-secondary-800)',
                    softActiveBg: 'var(--joy-palette-secondary-600)',
                    // @ts-ignore
                    softActiveColor: 'var(--joy-palette-secondary-100)',
                    plainColor: 'var(--joy-palette-secondary-300)',
                    plainActiveBg: 'var(--joy-palette-secondary-700)',
                    plainHoverBg:'var(--joy-palette-secondary-800)'
                }
            }
        }
    },
    components: {
        JoyTypography: {
            styleOverrides: {
                root: {
                    textAlign: "start"
                }
            }
        }
    }
})

export default regularTheme